import { graphql } from "@/gql";

export const createRelocationMutation = graphql(`
  mutation CreateRelocation($input: CreateRelocationInput!) {
    createRelocation(input: $input) {
      id
      reference
    }
  }
`);

export const updateRelocationMutation = graphql(`
  mutation UpdateRelocation($id: ID!, $input: UpdateRelocationInput!) {
    updateRelocation(id: $id, input: $input) {
      id
    }
  }
`);

export const duplicateRelocationMutation = graphql(`
  mutation DuplicateRelocation($id: ID!) {
    duplicateRelocation(id: $id) {
      id
    }
  }
`);

export const refreshRelocationDealScoreMutation = graphql(`
  mutation RefreshRelocationDealScore($relocationId: ID!) {
    refreshRelocationDealScore(relocation_id: $relocationId) {
      id
      deal_score
      deal_rated_at
    }
  }
`);

export const updateRelocationStatuses = graphql(`
  mutation ArchiveRelocations($ids: [ID!]!, $status: RelocationStatus!) {
    updateRelocationStatuses(ids: $ids, status: $status)
  }
`);

export const addDestinationMutation = graphql(`
  mutation AddDestinations($relocationId: ID!, $officeIds: [ID!]!) {
    addRelocationDestinations(
      relocationId: $relocationId
      destinationOfficeIds: $officeIds
    ) {
      id
    }
  }
`);

export const promoteRelocationMutation = graphql(`
  mutation PromoteRelocation(
    $id: ID!
    $budget_amount: Int!
    $platforms: [PromotionPlatform!]!
  ) {
    promoteRelocation(
      id: $id
      budget_amount: $budget_amount
      platforms: $platforms
    ) {
      id
      budget_amount
      channels {
        id
        platform
        status
        external_campaign_id
      }
    }
  }
`);

export const setRelocationPriorityMutation = graphql(`
  mutation SetRelocationPriority($id: ID!, $priority: Int) {
    setRelocationPriority(id: $id, priority: $priority)
  }
`);
